import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { push } from 'connected-react-router'
import { State } from 'index'
import dexieDb from 'lib/db'
import { switchStoreRefAction } from 'reducks/auth/actions'
import { initRootState } from 'reducks/auth/operations'
import { BrandType } from 'types/brand'

const switchStoreFromAdmin = (switchTo: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const brands: BrandType[] = getState().brand.brands
    const brand = brands.find((brand) => brand.store_refs.some((storeRef) => storeRef.id === switchTo.id))
    await dexieDb.auth.put({
      uid: getState().auth.uid,
      is_admin: getState().auth.is_admin,
      is_signed_in: getState().auth.is_signed_in,
      role: 9,
      brand_id: brand?.brand_ref?.id,
      shop_id: undefined,
      store_id: switchTo.id,
    })
    initRootState(dispatch)
    dispatch(switchStoreRefAction({ role: 9, brandRef: brand?.brand_ref, storeRef: switchTo, shopRef: undefined }))
    dispatch(push('/'))
  }
}

export default switchStoreFromAdmin
